import './style.css'
import * as jQuery from 'jquery'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
//import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
// to import fabric with npm : npm install fabric --save
import { fabric } from "fabric"

//test avec tga pour la texture de la boite -> pas mieux qu'avec les png
//import { TGALoader } from 'three/examples/jsm/loaders/TGALoader'

import FabricAddYellowRectangle from './FabricAddYellowRectangle.js'
import FabricAddText from './FabricAddText.js'

var FontFaceObserver = require('fontfaceobserver')
var fabricCanvas = new fabric.Canvas('fabricCanvas')
var numeroTexte = 1
var value = 1
if(typeof testUrl0 !== 'undefined' && window.location.hostname == testUrl0) { // si npm run build
  var base_dir = baseDir0
  var dist_dir = distDir0
  var modelesBoite = modelesBoite0
  var motifCameleon = motifCameleon0
  var couleursDispos = couleursDispos0
  var fonts = fonts0
  var svgDispo = svgDispo0
  var logoDispo = logoDispo0
  if(logoDispo == null){ logoDispo = [] }
  var cameraSettings = cameraSettings0
  var shadowSettings = shadowSettings0
  var positionDirLight = light1Settings0
  var positionDirLight2 = light2Settings0
  //var svgToLoad = svgToLoad0
  var jsonToLoad = jsonToLoad0
} else { // si npm run dev
  var base_dir = "./img/cartes/"
  var dist_dir = "./"
  var modelesBoite = ['moliere-cameleon', 'moliere-kraft-cameleon', 'coffret-cadeau-cameleon', 'kristie-cameleon', 'ronde-metallique-cameleon', 'carree-metallique-cameleon', 'bague-cameleon', 'valisette-cameleon','calendrier-avent-cameleon']
  var motifCameleon = ['carte-cameleon-i-01.jpg','carte-cameleon-i-02.jpg','carte-cameleon-i-03.jpg','carte-cameleon-i-03.jpg']
  var couleursDispos = ['red','blue','white', 'black','green','orange','pink','violet','grey','brown']
  var fonts = [["Dancing Script","https://fonts.googleapis.com/css2?family=Dancing+Script"],["Gochi Hand","https://fonts.googleapis.com/css2?family=Gochi+Hand"],["Noto Serif","https://fonts.googleapis.com/css2?family=Noto+Serif"],["Roboto","https://fonts.googleapis.com/css2?family=Roboto"],["Water Brush","https://fonts.googleapis.com/css2?family=Water+Brush"]]
  var logoDispo = []
  var svgDispo = []
  svgDispo[0] = []
  svgDispo[1] = []
  svgDispo[2] = []
  svgDispo[0]["url"] = dist_dir+'img/svg/cocoa1.svg'
  svgDispo[1]["url"] = dist_dir+'img/svg/cocoa2.svg'
  svgDispo[2]["url"] = dist_dir+'img/svg/cocoa3.svg'
  svgDispo[0]["filename"] = 'un_deux--cocoa1.svg'
  svgDispo[1]["filename"] = 'trois_quatre--cocoa2.svg'
  svgDispo[2]["filename"] = 'cinq_six--cocoa3.svg'
  var cameraSettings = [40,-17.74,29.46,10.28]
  var shadowSettings = [20,-20,20,-10]
  var positionDirLight = [-10, -10, -10]
  var positionDirLight2 = [10, 10, 10]
  //var jsonToLoad = null
}

/*####FABRICJS####*/
//on active le stack automatique pour respecter arriere / premier plan
fabricCanvas.preserveObjectStacking = true
//on empêche la sélection multiple
fabricCanvas.selection = false;
//on rend le Canvas pour bien avoir le fond transparent et pas le fond noir
fabricCanvas.renderAll()

//on désactive les controleurs des milieus de côté de tous les objets -> plus de déformation possible
fabric.Image.prototype.setControlsVisibility({
  tl:true,
  mt:false,
  tr:true,
  ml:false,
  mr:false,
  bl:true,
  mb:false,
  br:true,
  mtr:true
 })
 fabric.Group.prototype.setControlsVisibility({
  tl:true,
  mt:false,
  tr:true,
  ml:false,
  mr:false,
  bl:true,
  mb:false,
  br:true,
  mtr:true
 })
 fabric.IText.prototype.setControlsVisibility({
  tl:false,
  mt:false,
  tr:false,
  ml:false,
  mr:false,
  bl:false,
  mb:false,
  br:false,
  mtr:true
 })
//pour scaler depuis le centre des objets
 fabric.Object.prototype.set('centeredScaling',true)

// gestion des icônes outils
function outilsPerso() {
  jQuery('img#icone-textes').attr("src",dist_dir+"img/icones/ajouter-un-texte.svg")
  jQuery('img#icone-motifs').attr("src",dist_dir+"img/icones/ajouter-une-image.svg")
  jQuery('img#icone-logo').attr("src",dist_dir+"img/icones/ajouter-un-logo.svg")
  jQuery('img#icone-next').attr("src",dist_dir+"img/icones/valider.svg")
  jQuery('img#icone-retour').attr("src",dist_dir+"img/icones/retour.svg")
  //jQuery('img#icone-save').attr("src",dist_dir+"img/icones/icone-save.png")
}


/*var deleteIcon = "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Ebene_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='595.275px' height='595.275px' viewBox='200 215 230 470' xml:space='preserve'%3E%3Ccircle style='fill:%23F44336;' cx='299.76' cy='439.067' r='218.516'/%3E%3Cg%3E%3Crect x='267.162' y='307.978' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -222.6202 340.6915)' style='fill:white;' width='65.545' height='262.18'/%3E%3Crect x='266.988' y='308.153' transform='matrix(0.7071 0.7071 -0.7071 0.7071 398.3889 -83.3116)' style='fill:white;' width='65.544' height='262.179'/%3E%3C/g%3E%3C/svg%3E";
var img = document.createElement('img')
img.src = deleteIcon*/
fabric.Object.prototype.transparentCorners = false
fabric.Object.prototype.cornerColor = 'blue'
fabric.Object.prototype.cornerStyle = 'circle'
fabric.Object.prototype.cornerSize = 5
/*fabric.Object.prototype.controls.deleteControl = new fabric.Control({
  x: 0.5,
  y: -0.5,
  offsetY: 16,
  cursorStyle: 'pointer',
  mouseUpHandler: deleteObject,
  render: renderIcon,
  cornerSize: 16
});*/

function deleteObject(eventData, transform) {
  var target = transform.target
  var fabricCanvas = target.canvas
  fabricCanvas.remove(target)
  fabricCanvas.renderAll()
}
function renderIcon(ctx, left, top, styleOverride, fabricObject) {
  var size = this.cornerSize
  ctx.save()
  ctx.translate(left, top)
  ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle))
  ctx.drawImage(img, -size/2, -size/2, size, size)
  ctx.restore()
}

//listing fonts
var fontsBis = [];
for(var i=0;i<fonts.length;i++) {
  fontsBis[i] = fonts[i][0];
}

(function($){

  $.fn.fontselect = function(options) {  

    var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
    var settings = {
      style: 'font-select',
      placeholder: 'Select a font',
      lookahead: 2,
      api: 'https://fonts.googleapis.com/css?family=',
      fonts: fontsBis
    };
    
    var Fontselect = (function(){
    
      function Fontselect(original, o){
        this.$original = $(original);
        this.options = o;
        this.active = false;
        this.setupHtml();
        this.getVisibleFonts();
        this.bindEvents();

        var font = this.$original.val();
        if (font) {
          this.updateSelected();
          this.addFontLink(font);
        }
      }
      
      Fontselect.prototype.bindEvents = function(){
        var self = this;
        //on charge les polices tant bien que mal ^^
        self.toggleDrop()
        this.activateFont
        self.toggleDrop()
        // Close dropdown automatically on clicks outside dropdown
        $(document).click(function(event){
          if(self.active && !$(event.target).parents('#fontSelect-'+ self.$original.id).length){
            self.toggleDrop();
          }
        });
        $('li', this.$results)
        .click(__bind(this.selectFont, this))
        .mouseenter(__bind(this.activateFont, this))
        .mouseleave(__bind(this.deactivateFont, this));
        $('span', this.$select).click(__bind(this.toggleDrop, this));
        this.$arrow.click(__bind(this.toggleDrop, this));
      };

      Fontselect.prototype.toggleDrop = function(ev){
        if(this.active){
          this.$element.removeClass('font-select-active');
          this.$drop.hide();
          clearInterval(this.visibleInterval);
        } else {
          this.$element.addClass('font-select-active');
          this.$drop.show();
          this.moveToSelected();
          this.visibleInterval = setInterval(__bind(this.getVisibleFonts, this), 500);
        }
        this.active = !this.active;
      };
      
      Fontselect.prototype.selectFont = function(){
        var font = $('li.active', this.$results).data('value');
        this.$original.val(font).change();
        this.updateSelected();
        this.toggleDrop();
      };
      
      Fontselect.prototype.moveToSelected = function(){
        var $li, font = this.$original.val();
        if (font){
          $li = $("li[data-value='"+ font +"']", this.$results);
        } else {
          $li = $("li", this.$results).first();
        }
        this.$results.scrollTop($li.addClass('active')[0].offsetTop);
      };
      
      Fontselect.prototype.activateFont = function(ev){
        $('li.active', this.$results).removeClass('active');
        $(ev.currentTarget).addClass('active');
      };
      
      Fontselect.prototype.deactivateFont = function(ev){
        $(ev.currentTarget).removeClass('active');
      };
      
      Fontselect.prototype.updateSelected = function(){
        var font = this.$original.val();
        $('span', this.$element).text(this.toReadable(font)).css(this.toStyle(font));
      };
      
      Fontselect.prototype.setupHtml = function(){
        this.$original.empty().hide();
        this.$element = $('<div>', {'id': 'fontSelect-'+this.$original.id, 'class': this.options.style});
        this.$arrow = $('<div><b><i class="material-icons chevron_right">&#xe5cc;</i></b></div>');
        this.$select = $('<a><span>'+ this.options.placeholder +'</span></a>');
        this.$drop = $('<div>', {'class': 'fs-drop'});
        this.$results = $('<ul>', {'class': 'fs-results'});
        this.$original.after(this.$element.append(this.$select.append(this.$arrow)).append(this.$drop));
        this.$drop.append(this.$results.append(this.fontsAsHtml())).hide();
      };
      
      Fontselect.prototype.fontsAsHtml = function(){
        var l = this.options.fonts.length;
        var r, s, h = '';
        for(var i=0; i<l; i++){
          r = this.toReadable(this.options.fonts[i]);
          s = this.toStyle(this.options.fonts[i]);
          h += '<li data-value="'+ this.options.fonts[i] +'" style="font-family: '+s['font-family'] +'; font-weight: '+s['font-weight'] +'">'+ r +'</li>';
        }
        return h;
      };
      
      Fontselect.prototype.toReadable = function(font){
        return font.replace(/[\+|:]/g, ' ');
      };
      
      Fontselect.prototype.toStyle = function(font){
        var t = font.split(':');
        return {'font-family': this.toReadable(t[0]), 'font-weight': (t[1] || 400)};
      };
      
      Fontselect.prototype.getVisibleFonts = function(){
        if(this.$results.is(':hidden')) return;
        var fs = this;
        var top = this.$results.scrollTop();
        var bottom = top + this.$results.height();
        if(this.options.lookahead){
          var li = $('li', this.$results).first().height();
          bottom += li*this.options.lookahead;
        }
        $('li', this.$results).each(function(){
          var ft = $(this).position().top+top;
          var fb = ft + $(this).height();
          if ((fb >= top) && (ft <= bottom)){
            var font = $(this).data('value');
            fs.addFontLink(font);
          }
        });
      };
      
      Fontselect.prototype.addFontLink = function(font){
        var link = this.options.api + font;
        if ($("link[href*='" + font + "']").length === 0){
          $('link:last').after('<link href="' + link + '" rel="stylesheet" type="text/css">');
        }
      };
      return Fontselect;
    })();

    return this.each(function() {   
      // If options exist, lets merge them
      if (options) $.extend( settings, options );
      return new Fontselect(this, settings);
    });
  };
})(jQuery);

const monText = new FabricAddText('Saisissez votre texte', '#97805b', 'center')
document.getElementById('addText').onclick = function()
{
  AddText(monText)
}
  function AddText(objText) {
    
    const ajouterDuTexte = new fabric.IText(objText.text, objText,{id:numeroTexte})
    var attribute = 'fieldNumber'
    ajouterDuTexte[attribute]=numeroTexte
    fabricCanvas.setActiveObject(ajouterDuTexte)
    fabricCanvas.getActiveObject().set('fontSize', 30)
    fabricCanvas.add(ajouterDuTexte)
    fabricCanvas.getActiveObject().center()
    //changeMyColorForCameleon(0)
    jQuery('.mesTextes').append('<p class="inputTextes zoneDeTexteNumero'+numeroTexte+'"><input numeroduformulaire="'+numeroTexte+'" type="text" class="name" name="name" value="'+ajouterDuTexte.text+'"></p>')
    numeroTexte++
    fabricCanvas.renderAll()
  }

//modif text depuis l'input HTML
jQuery('#v-pills-home').on('keyup', 'input', function() {
  var fielNumberDeLInput = this.attributes.numeroduformulaire.value
  var texteSurCanvasAModifier = fabricCanvas._objects.filter(obj => {
    return obj.fieldNumber == fielNumberDeLInput
  })
  fabricCanvas.discardActiveObject()
  fabricCanvas.setActiveObject(texteSurCanvasAModifier[0])
  texteSurCanvasAModifier[0].set('text', this.value)
  fabricCanvas.renderAll()
})
//quand on focus un input text, ça sélectionne l'objet equivalent sur le canvas et ça fait apparaître la barre blanche
jQuery('#v-pills-home').on('focus', 'input.name', function() {
  var fielNumberDeLInput = this.attributes.numeroduformulaire.value
  console.log("fielNumberDeLInput = this.attributes.numeroduformulaire.value : "+this.attributes.numeroduformulaire.value)
  var texteSurCanvasAModifier = fabricCanvas._objects.filter(obj => {
    return obj.fieldNumber == fielNumberDeLInput
  })
  fabricCanvas.discardActiveObject()
  console.log("texteSurCanvasAModifier[0] : "+texteSurCanvasAModifier[0])
  fabricCanvas.setActiveObject(texteSurCanvasAModifier[0])
  fabricCanvas.renderAll()
  jQuery('.fixedBottom').css('bottom','0px')
})

//modif text depuis le canvas
document.onkeyup = function(e) {
    var texteSansRetour = ""
    var objSelected = fabricCanvas.getActiveObject()
    
    if (objSelected && objSelected.type === "i-text") {
      var numeroTexte = objSelected.fieldNumber
      for(var i=0; i<objSelected.textLines.length; i++){
        texteSansRetour += objSelected.textLines[i]
      }
      objSelected.on('object:updated', jQuery('.mesTextes .zoneDeTexteNumero'+objSelected.fieldNumber+' input').val(texteSansRetour))
      objSelected.set('text',texteSansRetour)
      if (objSelected.hiddenTextarea != null){
        objSelected.hiddenTextarea.value=texteSansRetour
      }
    } 
    
    fabricCanvas.renderAll()
}

var changingFont = function(fontstyle) {
  document.getElementById("output-text").className = "text-center " + fontstyle.value;
}

jQuery(function(){
  jQuery('#font').fontselect().change(function(){
    // replace + signs with spaces for css
    var font = $(this).val().replace(/\+/g, ' ');
    // split font into family and weight
    font = font.split(':');
    fabricCanvas.getActiveObject().set('fontFamily', font[0])
    fabricCanvas.renderAll()
    
  });
});
jQuery('#fontSelect-undefined > a > span').onchange = function() {
  fabricCanvas.getActiveObject().set('fontFamily', this.value)
  fabricCanvas.renderAll()
}

//window.listingCouleurs=listingCouleurs
function listingCouleurs(){
  var linkCouleurDispos = ""
  for (let j = 0; j<couleursDispos.length; j++){
    linkCouleurDispos += '<a onclick="changeMyColor('+j+')" href="#!"><div style="width:38px; height:38px; background-color:'+couleursDispos[j]+'; display:inline-block; margin:2px;border-radius:25px;"></div></a>'
  } 
  jQuery('.couleursDispos').html(linkCouleurDispos)
  
}

listingCouleurs()

// Appliquer la couleur suivant le choix pour les boites Caméléon
document.getElementById('colorPickerForCameleonTxt').oninput = function() {
  changeMyColorForCameleonTxt()
}
document.getElementById('colorPickerForCameleonSvg').oninput = function() {
  changeMyColorForCameleonSvg()
}

// Appliquer la fontSize au texte actif
jQuery('#font-size').on("input change", function() {
  fabricCanvas.getActiveObject().set("fontSize", this.value)
  fabricCanvas.renderAll()
})
// Appliquer le Gras au texte actif
document.getElementById('font-weight').onclick = function() {
  if(fabricCanvas.getActiveObject().get('fontWeight')=="normal"){
    fabricCanvas.getActiveObject().set("fontWeight", "bold")
    jQuery(this).addClass('active')
  }
  else{
    fabricCanvas.getActiveObject().set("fontWeight", "normal")
    jQuery(this).removeClass('active')
  }
  fabricCanvas.renderAll()
}
// Appliquer l'italic' au texte actif
document.getElementById('italic').onclick = function() {
  if(fabricCanvas.getActiveObject().get('fontStyle')=="normal"){
    fabricCanvas.getActiveObject().set("fontStyle", "italic")
    jQuery(this).addClass('active')
  }
  else{
    fabricCanvas.getActiveObject().set("fontStyle", "normal")
    jQuery(this).removeClass('active')
  }
  fabricCanvas.renderAll()
}

//Supprimer texte
document.getElementById('supprimerTexte').onclick = function() {
  jQuery('.mesTextes .zoneDeTexteNumero'+fabricCanvas.getActiveObject().fieldNumber+'').remove()
  fabricCanvas.remove(fabricCanvas.getActiveObject())
  fabricCanvas.renderAll()
}
//dupliquer texte 
document.getElementById('dupliquerTexte').onclick = function() {
  jQuery('.mesTextes').append('<p class="inputTextes zoneDeTexteNumero'+numeroTexte+'"><input numeroduformulaire="'+numeroTexte+'" type="text" class="name" name="name" value="'+fabricCanvas.getActiveObject().text+'"></p>')
  var object = fabricCanvas.getActiveObject()
  object.clone(function(clone) {
    fabricCanvas.add(clone.set({
          top: object.top + 30,
          fieldNumber: numeroTexte
    }))
  }) 
  var objetDuplique = fabricCanvas._objects.filter(obj => {
    return obj.fieldNumber == numeroTexte
  }) 
  fabricCanvas.setActiveObject(objetDuplique[0])
  numeroTexte++
}

//Supprimer svg
document.getElementById('supprimerSvg').onclick = function() {
  fabricCanvas.remove(fabricCanvas.getActiveObject())
  fabricCanvas.renderAll()
}
//dupliquer svg 
document.getElementById('dupliquerSvg').onclick = function() {
  var object = fabricCanvas.getActiveObject();
  var clonedSvg = object.clone(function(clone) {
    fabricCanvas.add(clone.set({
      top: object.top + 30
    }))
  })
  var leClone = fabricCanvas._objects[(fabricCanvas._objects.length)-1]
  fabricCanvas.setActiveObject(leClone)
}
//Supprimer logo
document.getElementById('supprimerLogo').onclick = function() {
  fabricCanvas.remove(fabricCanvas.getActiveObject())
  fabricCanvas.renderAll()
}

//Mettre en arrière plan
var mesBouttonsArriere = document.getElementsByClassName('arrierePlan')
  for (var i = 0; i < mesBouttonsArriere.length; i++) {
    mesBouttonsArriere[i].onclick = function() {
      var object = fabricCanvas.getActiveObject()
      object.sendToBack()
      fabricCanvas.renderAll()
    }
  }

//Mettre au premier plan
var mesBouttonsAvant = document.getElementsByClassName('premierPlan')
  for (var i = 0; i < mesBouttonsAvant.length; i++) {
    mesBouttonsAvant[i].onclick = function() {
      var object = fabricCanvas.getActiveObject()
      object.bringToFront()
      fabricCanvas.renderAll()
    }
  }

//Centrer Horizontalement
var centrerHorizontalement = document.getElementsByClassName('centrerH')
  for (var i = 0; i < centrerHorizontalement.length; i++) {
    centrerHorizontalement[i].onclick = function() {
      var object = fabricCanvas.getActiveObject()
      object.centerH()
      fabricCanvas.renderAll()
    }
  }

//Centrer Verticalement
var centrerVerticalement = document.getElementsByClassName('centrerV')
for (var i = 0; i < centrerVerticalement.length; i++) {
  centrerVerticalement[i].onclick = function() {
    var object = fabricCanvas.getActiveObject()
    object.centerV()
    fabricCanvas.renderAll()
  }
}


//simule le click sur l'outils texte pour synchro des outils
//mise à jour de l'affichage des boutons "bold" et "italic"
window.clickOnTextTool=clickOnTextTool
function clickOnTextTool(){
  jQuery('#mesTextes').trigger('click')
  if(fabricCanvas.getActiveObject().get('fontWeight')=="normal"){
    jQuery('#font-weight').removeClass('active')
  }
  else{
    jQuery('#font-weight').addClass('active')
  }
  if(fabricCanvas.getActiveObject().get('fontStyle')=="normal"){
    jQuery('#italic').removeClass('active')
  }
  else{
    jQuery('#italic').addClass('active')
  }
  
}
//simule le click sur l'outils svg pour synchro des outils
window.clickOnSvgTool=clickOnSvgTool
function clickOnSvgTool(){
  jQuery('#mesSvg').trigger('click')
}
//simule le click sur l'outils logo pour synchro des outils
window.clickOnLogoTool=clickOnLogoTool
function clickOnLogoTool(){
  jQuery('#mesLogos').trigger('click')
}

//quand je sélectionne un objet sur le canvas, je teste si c'est un texte ou un svg
//et j'affiche le panel qui correspond
//et j'affiche ou masque la barre fixedBottom
fabricCanvas.on("selection:created", function(obj){
   
	if(obj.selected[0].get('type')==="i-text"){
    //je charge les bonnes valeurs dans le formulaire
    document.getElementById('font-size').value=obj.selected[0].fontSize

    jQuery('#fontSelect-undefined > a > span ').css("font-family","\'"+obj.selected[0].fontFamily+"\'")
    jQuery('#fontSelect-undefined > a > span ').text(obj.selected[0].fontFamily)
    document.getElementById('colorPickerForCameleonTxt').value=obj.selected[0].fill
    jQuery('.clr-field').css("color", obj.selected[0].fill)
    clickOnTextTool()
    jQuery('.fixedBottom').css('bottom','0px')
  } else if(obj.selected[0].get('type')==="group"){
    document.getElementById('colorPickerForCameleonSvg').value=obj.selected[0]._objects[1].fill
    jQuery('.clr-field').css("color", obj.selected[0]._objects[1].fill)
    clickOnSvgTool()
    jQuery('.fixedBottom').css('bottom','0px')
  } else if(obj.selected[0].get('type')==="image"){
    clickOnLogoTool()
    jQuery('.fixedBottom').css('bottom','0px')
  } 
})
fabricCanvas.on("selection:updated", function(obj){
	if(obj.selected[0].get('type')==="i-text"){
    //je charge les bonnes valeurs dans le formulaire
    document.getElementById('font-size').value=obj.selected[0].fontSize
    jQuery('#fontSelect-undefined > a > span ').css("font-family","\'"+obj.selected[0].fontFamily+"\'")
    jQuery('#fontSelect-undefined > a > span ').text(obj.selected[0].fontFamily)
    document.getElementById('colorPickerForCameleonTxt').value=obj.selected[0].fill
    jQuery('.clr-field').css("color", obj.selected[0].fill)
    clickOnTextTool()
    jQuery('.fixedBottom').css('bottom','0px')
  } else if(obj.selected[0].get('type')==="group"){
    document.getElementById('colorPickerForCameleonSvg').value=obj.selected[0]._objects[1].fill
    jQuery('.clr-field').css("color", obj.selected[0]._objects[1].fill)
    clickOnSvgTool()
    jQuery('.fixedBottom').css('bottom','0px')
  } else if(obj.selected[0].get('type')==="image"){
    clickOnLogoTool()
    jQuery('.fixedBottom').css('bottom','0px')
  } 
})
fabricCanvas.on('selection:cleared', function() {
  jQuery('.fixedBottom').css('bottom','-500px')
})

//on désélectionne les objet du fabricCanvas pour que la barre fixedBottom soit bien synchro
jQuery("#mesTextes, #mesSvg, #mesLogos, #retour, #suivant").on('mouseup', function(e) 
{
  fabricCanvas.discardActiveObject().renderAll()
});
//pour produits autres que Caméléon -> on donne une liste de couleurs
window.changeMyColor= changeMyColor;
function changeMyColor(couleursDispoArg){
  var obj = fabricCanvas.getActiveObject()
  if (obj && obj._objects) {
    for (var i = 1; i < obj._objects.length; i++) {
      obj._objects[i].set({
        fill:couleursDispos[couleursDispoArg]
      })
    }
  }
  else{
    fabricCanvas.getActiveObject().set({fill:couleursDispos[couleursDispoArg]})
  }
  fabricCanvas.renderAll()
}

//pour produits caméléon -> on laisse le choix de la couleur
//TXT
window.changeMyColorForCameleonTxt= changeMyColorForCameleonTxt;
function changeMyColorForCameleonTxt(){
  var colorPicked = document.getElementById('colorPickerForCameleonTxt')
  var obj = fabricCanvas.getActiveObject()
  if (obj && obj._objects) {
    for (var i = 1; i < obj._objects.length; i++) {
      obj._objects[i].set({
        fill:colorPicked.value
      })
    }
  }
  else{
    fabricCanvas.getActiveObject().set({fill:colorPicked.value})
  }
  fabricCanvas.renderAll()
}
//SVG
window.changeMyColorForCameleonSvg= changeMyColorForCameleonSvg;
function changeMyColorForCameleonSvg(){
  var colorPicked = document.getElementById('colorPickerForCameleonSvg')
  var obj = fabricCanvas.getActiveObject()
  if (obj && obj._objects) {
    for (var i = 1; i < obj._objects.length; i++) {
      obj._objects[i].set({
        fill:colorPicked.value
      })
    }
  }
  else{
    fabricCanvas.getActiveObject().set({fill:colorPicked.value})
  }
  fabricCanvas.renderAll()
}

//INSERTION SVG & LOGOS CLIENTS
for (let i = 0; i<logoDispo.length; i++){
  jQuery('.insertionLogo').prepend('<div class="logoParent"><a onclick="putLogo(\''+logoDispo[i]["url"]+'\')"><img src="' + logoDispo[i]["url"] + '" class="logo"/></a><i class="material-icons cancel delete-logo" onclick="deleteLogoBis('+logoDispo[i]["id_perso_media"]+')">&#xe5c9;</i></div>')
}
var catsave = "";
for (let i = 0; i<svgDispo.length; i++){  
  var catsvg = svgDispo[i]["filename"].split("--");
  if(catsvg[0] != catsave) { jQuery('.insertionSvg').append('<span class="categorieSvg">'+catsvg[0].replace(/_/g,' ')+'</span>'); }
  catsave = catsvg[0];
  jQuery('.insertionSvg').append('<a onclick="putSvg('+i+')"> <img src="' + svgDispo[i]["url"] + '" class="svg"/></a>')

}

//fonction d'insertion des image png jpg et autres logos
window.putLogo = putLogo
function putLogo(urlInArray) {
  fabric.util.loadImage(urlInArray, function(img) {
    var imgObj = new fabric.Image(img)
    imgObj.set({left: 50, top: 50, scaleX:1/(imgObj.width/200), scaleY:1/(imgObj.width/200)})
    fabricCanvas.add(imgObj).renderAll()
    var leLogo = fabricCanvas._objects[(fabricCanvas._objects.length)-1]
    fabricCanvas.setActiveObject(leLogo)
    fabricCanvas.getActiveObject().center()
    fabricCanvas.renderAll()
  }) 
}

//fonction d'insertion des image svg
window.putSvg = putSvg
function putSvg(numberSvgInArray) {
  fabric.loadSVGFromURL(svgDispo[numberSvgInArray]["url"], function(objects, options) {
    var obj = fabric.util.groupSVGElements(objects, options)
    
    //on rend le fond blanc transparent
    obj._objects[0].set({
    fill:'rgba(0,0,0,0)'})

    fabricCanvas.setActiveObject(obj)
    fabricCanvas.add(obj).renderAll()
    fabricCanvas.getActiveObject().center()
    //changeMyColorForCameleon(0)
  })  
}

//traitement détourage des images/logos
jQuery('#editLogo').click(function () {
  //jQuery('#editLogo').attr('disabled',true)
  var logo = fabricCanvas.getActiveObject()
  var filter = new fabric.Image.filters.RemoveColor({
    threshold: 0.2,
    color: '#FFFFFF'
  });
  logo.filters.push(filter);
  logo.applyFilters();
  fabricCanvas.renderAll()
})

window.putJsonPerso = putJsonPerso
function putJsonPerso(jsonToLoad) {
  fabricCanvas.loadFromJSON(jsonToLoad, fabricCanvas.renderAll.bind(fabricCanvas), function(o, object) {})
  var canvasJSONbis = JSON.parse(jsonToLoad)
  for(var i=0; i<canvasJSONbis.objects.length; i++){
    if(canvasJSONbis.objects[i].type == "i-text"){
      canvasJSONbis.objects[i]._forceClearCache = true
      jQuery('.mesTextes').append('<p class="inputTextes zoneDeTexteNumero'+canvasJSONbis.objects[i].fieldNumber+'"><input class="name" numeroduformulaire="'+canvasJSONbis.objects[i].fieldNumber+'" type="text" id="inputDeTexteNumero'+canvasJSONbis.objects[i].fieldNumber+'" name="name" value="'+canvasJSONbis.objects[i].text+'"></p>')
      jQuery('#inputDeTexteNumero'+canvasJSONbis.objects[i].fieldNumber).trigger('change')
      numeroTexte = canvasJSONbis.objects[i].fieldNumber + 1
    }    
  }
}
//fabricCanvas.renderAll()


/*window.findMyFont = findMyFont
function findMyFont(){
  let mesFonts = fabricCanvas.getObjects().filter(o => o.get('type') === 'i-text').map(o => o.fontFamily)
  console.log('mesFonts : '+mesFonts)

    WebFont.load({
        google: {
          families: [...mesFonts],
        },
        active: () => {
          console.log("chu prêt ! ! !")
          fabricCanvas.renderAll()
        },
      })*/
    


//fonction d'insertion des cartes
jQuery('#fabricCanvas').css('background-image','url(' + base_dir+motifCameleon[1] + ')')
outilsPerso()

//on décalle le chargement de la carte de 2 sec
//on charge toutes les polices dès le chargement de la page -> lignes 2, 3 et 4 de la fonction bindEvents
  if(jsonToLoad != null) {
    setTimeout(() => {
      putJsonPerso(jsonToLoad)
    }, 2000)
  }
  

//retour au choix du modèle ou motif
window.jsonThenSelect=jsonThenSelect
function jsonThenSelect(b,m) {
  var url = "/modules/eb_personnalisation/ajax/eb_personnalisation-ajax.php";

  var canvasJSONbis = fabricCanvas.toJSON(['fieldNumber'])

  jQuery.ajax({
      url: url,
      type: 'POST',
      cache: false,
      data: {
          controleur: "Eb_PersonnalisationPersonnaliserVosPackagingsModuleFrontController",
          fonction: "back_to_select",
          json: JSON.stringify(canvasJSONbis),
          boite: b,
          motif: m,
      },
      success: function(data) {
          //alert(data);
          //console.log(data);

          var infos = JSON.parse(data);
          window.location.href=infos["link"];            
      },
      error: function(jqXHR, textStatus, errorThrown) {
          console.log('Error: ' + textStatus + ' ' + errorThrown);
      }
  });    
}

//passage à l'étape 4 dans l'interface
window.svgToNextF=svgToNextF
function svgToNextF(){
  // activation manuelle du loader
  loaderIn("Génération de votre personnalisation");

  /*fabricCanvas.getActiveObject().set("hasControls",false)
  fabricCanvas.getActiveObject().set("hasBorders",false)
  fabricCanvas.renderAll()*/

  // envoi de la personnalisation seule FABRIC > svg
  var canvasSVG = fabricCanvas.toSVG()
  jQuery("#svgToNext").attr("value",String(canvasSVG))

  var canvasJSON = fabricCanvas.toJSON(['fieldNumber'])
  jQuery("#jsonToNext").attr("value",JSON.stringify(canvasJSON))

  // envoi de la simulation complète THREE JS > jpg
  //fabricCanvas.discardActiveObject().renderAll();
  renderer.setClearColor( 0xffffff, 1)
  camera.position.set(cameraSettings[1],cameraSettings[2],cameraSettings[3])
  controls.update()
  renderer.render(scene, camera)
  var canvas2JpgData = renderer.domElement.toDataURL("image/jpeg",0.8)
  jQuery("#canvas2ToNext").attr("value",canvas2JpgData)

}






/*####THREEJS####*/
/**
 * Base
 */
// Debug
//const gui = new dat.GUI()

// Canvas THREE
const webglCanvas = document.querySelector('canvas.webglCanvas')

// Scene
const scene = new THREE.Scene()
scene.background = null

/**
 * environment map
 */
 //const cubeTextureLoader = 
 const environmentMapTexture = new THREE.CubeTextureLoader()
 .setPath(dist_dir+'img/environmentMaps/0/')
 .load([
  'px.jpg',
  'nx.jpg',
  'py.jpg',
  'ny.jpg',
  'pz.jpg',
  'nz.jpg'
])

/**
 * Carte Caméléon
 */

//Chargement de la carte sur l'objet Design
const textureDesignObject = new THREE.TextureLoader().load( base_dir+motifCameleon[1])

const materialDesignObject = new THREE.MeshBasicMaterial( { map: textureDesignObject} )
textureDesignObject.flipY = false
textureDesignObject.encoding = THREE.sRGBEncoding


const monCanvasFabric = document.getElementById('fabricCanvas')
//const theCtx = monCanvasFabric.getContext('2d'); -> inutile ici
const textureCanvas = new THREE.CanvasTexture(monCanvasFabric);
textureCanvas.flipY = false
textureCanvas.encoding = THREE.sRGBEncoding
textureCanvas.minFilter = THREE.NearestFilter
textureDesignObject.minFilter = THREE.NearestFilter
const materialCanvas = new THREE.MeshStandardMaterial({
    map: textureCanvas
  })


/**
 * Boite Caméléon
 */
//const textureLoader = new TGALoader()   //test avec tga au lieu de png -> pas ok
 const textureLoader = new THREE.TextureLoader()
 textureLoader.flipY = false
 const myRoughnessTexture = textureLoader.load(dist_dir+'img/cameleon-roughness.png')
 const myMetalnessTexture = textureLoader.load(dist_dir+'img/cameleon-metalness.png')
 const myKraftTexture = textureLoader.load(dist_dir+'img/cameleon-kraft.jpg')
 const valisetteNormalMapTexture = textureLoader.load(dist_dir+'img/normalMap/valisetteNormalMap.png')
 myRoughnessTexture.encoding = THREE.sRGBEncoding
 myMetalnessTexture.encoding = THREE.sRGBEncoding
 myKraftTexture.encoding = THREE.sRGBEncoding
 const materialKraft = new THREE.MeshStandardMaterial({
  map: myKraftTexture
})
const materialPlastoc = new THREE.MeshPhysicalMaterial({
})
const gltfLoader = new GLTFLoader()
var loadModele  = (monModele) =>
{
  gltfLoader.load(
    dist_dir+'models/boite/'+monModele+'.glb',
    (gltf) =>
    {
        gltf.scene.scale.set(1, 1, 1)
        gltf.scene.receiveShadow = true
        gltf.scene.castShadow = true
        scene.add(gltf.scene)

        myRoughnessTexture.wrapS = myRoughnessTexture.wrapT = THREE.RepeatWrapping
        myRoughnessTexture.offset.set(0,0)
        myRoughnessTexture.repeat.set(16,16)
        myMetalnessTexture.wrapS = myMetalnessTexture.wrapT = THREE.RepeatWrapping
        myMetalnessTexture.offset.set(0,0)
        myMetalnessTexture.repeat.set(16,16)
        myKraftTexture.wrapS = myKraftTexture.wrapT = THREE.RepeatWrapping
        myKraftTexture.offset.set(0,0)
        myKraftTexture.repeat.set(16,16)


        //on ne peut cibler les calques de blender que par le numéro gltf.scene.children[i]
        //et dans blender, i s'inscrémente au fur et à mesure de la création des éléments -> on n'a pas la main là-dessus
        //donc création d'une boucle pour parcourir les éléments
        for(var i = 0; i<gltf.scene.children.length;i++){
          // Objets avec vernis caméléon
          if(gltf.scene.children[i].name.includes("vernis-cameleon")){
            gltf.scene.children[i].material.roughnessMap = myRoughnessTexture
            gltf.scene.children[i].material.roughness = 1
            gltf.scene.children[i].material.envMap = environmentMapTexture
            gltf.scene.children[i].castShadow = true
            gltf.scene.children[i].receiveShadow = true
            
          }
          // Objet carton blanc
          else if(gltf.scene.children[i].name.includes("carton-blanc")){
            gltf.scene.children[i].material.color.setHex(0xffffff)
            gltf.scene.children[i].material.envMap = environmentMapTexture
            gltf.scene.children[i].receiveShadow = true
            gltf.scene.children[i].castShadow = true
            gltf.scene.children[i].material.roughness = 1
            gltf.scene.children[i].material.metalness = 0
          }
          // Objet Metal blanc
          else if(gltf.scene.children[i].name.includes("metal-blanc")){
            gltf.scene.children[i].material.color.setHex(0xffffff)
            gltf.scene.children[i].material.envMap = environmentMapTexture
            gltf.scene.children[i].castShadow = true
            gltf.scene.children[i].receiveShadow = true
            gltf.scene.children[i].material.roughness = 0
            gltf.scene.children[i].material.metalness = 0
          }
          // Objet Metal gris
          else if(gltf.scene.children[i].name.includes("metal-argent")){
            gltf.scene.children[i].material.color.setHex(0xffffff)
            gltf.scene.children[i].material.envMap = environmentMapTexture
            gltf.scene.children[i].castShadow = true
            gltf.scene.children[i].receiveShadow = true
            gltf.scene.children[i].material.roughness = 0.2
            gltf.scene.children[i].material.metalness = 1
          }
          // objet kraft
          else if(gltf.scene.children[i].name.includes("kraft")){
            //gltf.scene.children[i].material.color.setHex(0xffffff)
            gltf.scene.children[i].material = materialKraft
            gltf.scene.children[i].material.envMap = environmentMapTexture
            
            gltf.scene.children[i].castShadow = true
            gltf.scene.children[i].receiveShadow = true
            gltf.scene.children[i].material.roughness = 1
            gltf.scene.children[i].material.metalness = 0
            
          }

          // Objet "illustration"
          else if(gltf.scene.children[i].name == "illustration"){
            gltf.scene.children[i].material.map = textureDesignObject
            gltf.scene.children[i].material.envMap = environmentMapTexture
            gltf.scene.children[i].material.roughness = 1
            gltf.scene.children[i].material.metalness = 0
            gltf.scene.children[i].receiveShadow = true
          }
          // Objet "Perso"
          else if(gltf.scene.children[i].name == "perso"){
            gltf.scene.children[i].material.color.setHex( 0xffffff );
            gltf.scene.children[i].material.map = textureCanvas
            gltf.scene.children[i].material.transparent = true
            gltf.scene.children[i].material.envMap = environmentMapTexture
            gltf.scene.children[i].material.roughness = 1
            gltf.scene.children[i].material.metalness = 0
            gltf.scene.children[i].receiveShadow = true
          }

          // Objet "illustration-metal"
          else if(gltf.scene.children[i].name == "illustration-metal"){
            gltf.scene.children[i].material.map = textureDesignObject
            gltf.scene.children[i].material.envMap = environmentMapTexture
            gltf.scene.children[i].material.roughness = 0
            gltf.scene.children[i].material.metalness = 0
            gltf.scene.children[i].receiveShadow = true
          }
          // Objet "Perso-metal"
          else if(gltf.scene.children[i].name == "perso-metal"){
            gltf.scene.children[i].material.color.setHex( 0xffffff );
            gltf.scene.children[i].material.map = textureCanvas
            gltf.scene.children[i].material.transparent = true
            gltf.scene.children[i].material.envMap = environmentMapTexture
            gltf.scene.children[i].material.roughness = 0
            gltf.scene.children[i].material.metalness = 0
            gltf.scene.children[i].receiveShadow = true
          }

          // Objet "plastoc"
          else if(gltf.scene.children[i].name.includes("plastoc")){
            gltf.scene.children[i].material = materialPlastoc
            gltf.scene.children[i].material.color.setHex( 0xffffff );
            gltf.scene.children[i].material.transparent = false
            gltf.scene.children[i].material.envMap = environmentMapTexture
            gltf.scene.children[i].material.roughness = 0
            gltf.scene.children[i].material.transmission = 0.5
            gltf.scene.children[i].material.thickness = 0
            gltf.scene.children[i].material.envMapIntensity = 3
            gltf.scene.children[i].material.clearcoat = 1
            gltf.scene.children[i].material.clearcoatRoughness = 0
            gltf.scene.children[i].receiveShadow = true
          }

          // Objet valisette
          else if(gltf.scene.children[i].name.includes("valisette-top")){
            gltf.scene.children[i].material.color.setHex(0xffffff)
            gltf.scene.children[i].material.map = textureDesignObject
            gltf.scene.children[i].material.envMap = environmentMapTexture
            gltf.scene.children[i].castShadow = true
            gltf.scene.children[i].receiveShadow = true
            gltf.scene.children[i].material.roughness = 1
            gltf.scene.children[i].material.metalness = 0
            gltf.scene.children[i].material.normalMap = valisetteNormalMapTexture
            gltf.scene.children[i].material.normalScale.set(4, 4)
        }

        // Objet or brillant
        else if(gltf.scene.children[i].name.includes("or-brillant")){
          gltf.scene.children[i].material.envMap = environmentMapTexture
          gltf.scene.children[i].material.roughness = 0
          gltf.scene.children[i].material.metalness = 1
          gltf.scene.children[i].castShadow = true
          gltf.scene.children[i].receiveShadow = true
        }

        // Objet or mat
        else if(gltf.scene.children[i].name.includes("or-mat")){
          gltf.scene.children[i].material.envMap = environmentMapTexture
          gltf.scene.children[i].material.roughness = 0.5
          gltf.scene.children[i].material.metalness = 0.5
          gltf.scene.children[i].castShadow = true
          gltf.scene.children[i].receiveShadow = true
        }
      }  
        
    }
  )
}
loadModele(modelesBoite[1])

//THREE LUMIERES
var AmbientLight = new THREE.AmbientLight(0xffffff,0.1)
scene.add(AmbientLight)

var dirLight = new THREE.DirectionalLight(0xffffff, 0.6)
dirLight.position.set(parseFloat(positionDirLight[0]), parseFloat(positionDirLight[1]), parseFloat(positionDirLight[2]))
dirLight.castShadow = true
dirLight.shadow.camera.left = parseFloat(shadowSettings[0])
dirLight.shadow.camera.right = parseFloat(shadowSettings[1])
dirLight.shadow.camera.top = parseFloat(shadowSettings[2])
dirLight.shadow.camera.bottom = parseFloat(shadowSettings[3])
dirLight.shadow.normalBias = 0.1
dirLight.shadow.mapSize.width = 4096
dirLight.shadow.mapSize.height = 4096
scene.add(dirLight)

/*
const spotLightCameraHelper = new THREE.CameraHelper(dirLight.shadow.camera)
scene.add(spotLightCameraHelper)
*/

var dirLight2 = new THREE.DirectionalLight(0xffffff, 0.6);
dirLight2.position.set(parseFloat(positionDirLight2[0]), parseFloat(positionDirLight2[1]), parseFloat(positionDirLight2[2]))
dirLight2.castShadow = true
dirLight2.shadow.camera.left = parseFloat(shadowSettings[0])
dirLight2.shadow.camera.right = parseFloat(shadowSettings[1])
dirLight2.shadow.camera.top = parseFloat(shadowSettings[2])
dirLight2.shadow.camera.bottom = parseFloat(shadowSettings[3])
dirLight2.shadow.normalBias = 0.1
dirLight2.shadow.mapSize.width = 4096
dirLight2.shadow.mapSize.height = 4096
scene.add(dirLight2)




/**
 * Sizes
 */
 const webglCanvasCol = document.getElementById('webglCanvasCol');
 const sizes = {
     width: webglCanvasCol.clientWidth,
     height: webglCanvasCol.clientWidth
 }
 
 window.addEventListener('resize', () =>
 {
     // Update sizes
     sizes.width = webglCanvasCol.clientWidth,
     sizes.height = webglCanvasCol.clientWidth,

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(window.devicePixelRatio)

})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(cameraSettings[0], sizes.width / sizes.height, 0.1, 100)
camera.position.set(cameraSettings[1],cameraSettings[2],cameraSettings[3])
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, webglCanvas)
controls.target.set(0, 0, 0)
controls.enableDamping = true
controls.enableZoom = false


//THREE RENDERER
const renderer = new THREE.WebGLRenderer({
    canvas: webglCanvas,
    antialias: true,
    alpha: true
})
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.shadowMap.autoUpdate = true

renderer.outputEncoding = THREE.sRGBEncoding
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(window.devicePixelRatio)
renderer.setClearColor( 0xffffff, 0)

/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime
    textureCanvas.needsUpdate = true
    
    
    // Model animation
    /*if(mixer)
    {
        mixer.update(deltaTime)
    }*/

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
   
}
tick()


/*gui.add(AmbientLight,'intensity', 0, 1, 0.01).name('Lumière ambiante')
gui.add(dirLight,'intensity', 0, 1, 0.01).name('Intensité Lum. directionnelle')
gui.add(dirLight.position,'x', -100, 100, 0.01).name('x Lum. directionnelle')
gui.add(dirLight.position,'y', -100, 100, 0.01).name('y Lum. directionnelle')
gui.add(dirLight.position,'z', -100, 100, 0.01).name('z Lum. directionnelle')
gui.add(dirLight2,'intensity', 0, 1, 0.01).name('Intensité Lum. directionnelle')
gui.add(dirLight2.position,'x', -100, 100, 0.01).name('x Lum. directionnelle')
gui.add(dirLight2.position,'y', -100, 100, 0.01).name('y Lum. directionnelle')
gui.add(dirLight2.position,'z', -100, 100, 0.01).name('z Lum. directionnelle')
gui.add( camera.position , 'x', -100, 100,0.01).name('x caméra')
gui.add( camera.position , 'y', -100, 100,0.01).name('y caméra')
gui.add( camera.position , 'z', -100, 100,0.01).name('z caméra')*/
